<template>
  <div>
    <PBannerBase height="auto" :inative="false" :isDefault="false" warning>
      <template #title>AtenÃ§Ã£o</template>
      A integraÃ§Ã£o "API - Marvin" foi desabilitada e nÃ£o estÃ¡ mais
      disponÃ­vel.
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
</script>
